(()=>{
  document.querySelectorAll('.rh-listen').forEach(sec=>{
    const dlg=sec.querySelector('.rh-dialog'); if(!dlg) return;
    const body=dlg.querySelector('.rh-dialog__body'); let opener=null;
    const close=()=>{ body.querySelectorAll('video,audio').forEach(m=>{try{m.pause()}catch(e){}}); if(dlg.open) dlg.close(); };
    dlg.addEventListener('close',()=>{ body.innerHTML=''; document.documentElement.classList.remove('rh-lock'); if(opener) opener.focus(); });
    dlg.querySelector('[data-rh-close]').addEventListener('click',close);
    dlg.addEventListener('click',e=>{ if(e.target===dlg) close(); });
    sec.querySelectorAll('[data-rh-demo]').forEach(btn=>btn.addEventListener('click',()=>{
      const tpl=document.getElementById('RhDemo-'+btn.dataset.rhDemo); if(!tpl) return;
      opener=btn; body.innerHTML=''; body.appendChild(tpl.content.cloneNode(true));
      const m=body.querySelector('video,audio');
      if(typeof dlg.showModal==='function') dlg.showModal(); else dlg.setAttribute('open','');
      document.documentElement.classList.add('rh-lock');
      if(m){ m.setAttribute('preload','auto'); const p=m.play(); if(p&&p.catch) p.catch(()=>{}); }
    }));
  });
})();
